/*! @pentacode/ui v0.1.0 */
import { t as e } from "./css-build-DcREbovZ.js";
// \0lit-plugin:css-sheet:./src/elements/assistant/reduced-motion.css.js
var t = e("@media (prefers-reduced-motion:reduce){:host,*,:before,:after{transition-duration:0s!important;transition-delay:0s!important;animation-duration:0s!important;animation-iteration-count:1!important}}");
export { t };

//# sourceMappingURL=reduced-motion.css-tEHc8kYn.js.map